const inkAlert = {
  controller: 'AlertMessagesController',
  template: `
  <div class="alerts">
    <div class="alert" uib-alert ng-repeat="alert in $ctrl.alerts"
      ng-class="'alert-' + (alert.type || 'warning')"
      dismiss-on-timeout="4000"
      close="$ctrl.closeAlert($index)">
      {{alert.msg}}
    </div>
  </div>
  `
};

angular
  .module('inkfinder')
  .component('inkAlert', inkAlert);



// WEBPACK FOOTER //
// ./components/alerts/alert-messages.component.js